// extracted by mini-css-extract-plugin
export var body = "_jw-0";
export var sectionHeader = "_jw-4";
export var shortcutColumns = "_jw-2";
export var shortcutList = "_jw-1";
export var shortcutSection = "_jw-3";